import React from 'react';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';
import { Typography, makeStyles } from '@material-ui/core';
import { SeriesStepper } from './SeriesStepper';
import { SeriesSignUpButton } from './SeriesSignUpButton';

const useStyles = makeStyles({
  stepperContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '20px 0px',
  },
  trackProgress: {
    maxWidth: '30%',
  },
});

export const SeriesStepperAuth = ({
  activeStep,
  stepsCount,
  seriesSiteCopy,
  navbarPageSiteCopy,
  isAuthenticated,
  trackingPath,
  item,
}) => {
  const classes = useStyles();

  const renderTrackProgressCTA = () => {
    const trackProgressCTA = _get(
      seriesSiteCopy,
      'pageCopy.trackProgressCTA',
      '',
    ).split('#learning-lab');

    return (
      <Typography variant="body2" className={classes.trackProgress}>
        {trackProgressCTA[0]}
        <Link to="/learning-lab">
          {_get(navbarPageSiteCopy, [
            'pageCopy',
            'submenu-labels',
            'learning-lab',
          ])}
        </Link>
        {trackProgressCTA[1]}
      </Typography>
    );
  };

  return (
    <div className={classes.stepperContainer}>
      <SeriesStepper
        activeStep={activeStep}
        stepsCount={stepsCount}
        seriesSiteCopy={seriesSiteCopy}
      />
      {isAuthenticated ? (
        renderTrackProgressCTA()
      ) : (
        <SeriesSignUpButton
          seriesSiteCopy={seriesSiteCopy}
          item={item}
          trackingPath={trackingPath}
        />
      )}
    </div>
  );
};
